import { getFullUrl } from './apiConfig';

const getAuthToken = () => localStorage.getItem('accessToken');

const createHeaders = (includeAuth = true) => {
  const headers = { 'Content-Type': 'application/json' };
  if (includeAuth) {
    const token = getAuthToken();
    if (token) headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

const handleResponse = async (response) => {
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || err.message || `${response.status} ${response.statusText}`);
  }
  return response.json();
};

const calendarService = {
  getCompanyHolidays: async (companyId) => {
    const url = getFullUrl(`holidays/${companyId}`);
    const res = await fetch(url, { method: 'GET', headers: createHeaders() });
    return handleResponse(res);
  },

  createHoliday: async (companyId, { date, name }) => {
    const url = getFullUrl(`holidays/${companyId}/create`);
    const res = await fetch(url, {
      method: 'POST',
      headers: createHeaders(),
      body: JSON.stringify({ date, name }),
    });
    return handleResponse(res);
  },

  updateHoliday: async (holidayId, payload) => {
    const url = getFullUrl(`holidays/${holidayId}/update`);
    const res = await fetch(url, {
      method: 'PUT',
      headers: createHeaders(),
      body: JSON.stringify(payload),
    });
    return handleResponse(res);
  },

  deleteHoliday: async (holidayId) => {
    const url = getFullUrl(`holidays/${holidayId}/delete`);
    const res = await fetch(url, { method: 'DELETE', headers: createHeaders() });
    return handleResponse(res);
  },

  getCompanyWeekdays: async (companyId) => {
    const url = getFullUrl(`weekdays/${companyId}`);
    const res = await fetch(url, { method: 'GET', headers: createHeaders() });
    return handleResponse(res);
  },

  setCompanyWeekdays: async (companyId, weekdaysArray) => {
    const url = getFullUrl(`weekdays/${companyId}/set`);
    const res = await fetch(url, {
      method: 'POST',
      headers: createHeaders(),
      body: JSON.stringify({ weekdays: weekdaysArray }),
    });
    return handleResponse(res);
  },

  updateCompanyWeekday: async (companyId, weekday, payload) => {
    const url = getFullUrl(`weekdays/${companyId}/${weekday}/update`);
    const res = await fetch(url, {
      method: 'PUT',
      headers: createHeaders(),
      body: JSON.stringify(payload),
    });
    return handleResponse(res);
  },
};

export default calendarService;
